module.exports = __webpack_public_path__ + "static/media/Gerb-38frame_blink.cf20b87d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Gerb-38frame_blink.gif
// module id = 32
// module chunks = 0